<form #referenceDataForm="ngForm"
	  [formGroup]="formGroup"
	  (ngSubmit)="saveChanges()">
	<div class="card-feature">
		<button ejs-button iconCss="fa fa-chevron-left" (click)="returnToList(false)" [attr.data-test-id]="'returnToListViewButton'">
			All {{ headerText }}
		</button>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col-xl-6">
				@if (formGroup.invalid && referenceDataForm.submitted) {
					<gandalf-lib-validation-messages
						[form]="formGroup"
						[requestObj]="requestObj">
					</gandalf-lib-validation-messages>
				}
				<div class="row mb-3" [attr.data-test-id]="'referenceDataNameFormGroup'">
					<label class="col-md-4 col-form-label required">{{ labelNameOrIdOnTribal }}</label>
					<div class="col-md-8">
						<input type="text" class="e-input" revFocusInput formControlName="value"/>
					</div>
				</div>
				<div class="row mb-3" [attr.data-test-id]="'referenceDataDescriptionFormGroup'">
					<label class="col-md-4 col-form-label">{{ labelDescriptionOrNameOnTribal }}</label>
					<div class="col-md-8">
						<input type="text" class="e-input"
							   formControlName="description"/>
					</div>
				</div>
				<div class="row mb-3">
					<div class="col-md-8 offset-sm-4">
						<ejs-checkbox [attr.data-test-id]="'referenceDataEditableCheckbox'" label="Editable" [checked]="isEditable()" disabled="true">
						</ejs-checkbox>
					</div>
				</div>
				<div class="row mb-3">
					<div class="col-md-8 offset-sm-4">
						<ejs-checkbox formControlName="active" label="Active"></ejs-checkbox>
					</div>
				</div>
				@if (mapsToMaster) {
					<div class="row mb-3">
						<label class="col-md-4 col-form-label">Maps to Master Data</label>
						<div class="col-md-8">
							<p class="form-control-static">{{ mapsToMaster }}</p>
						</div>
					</div>
				}
			</div>
		</div>
	</div>
	<div class="card-footer">
		<button ejs-button type="submit" [isPrimary]="true" [attr.data-test-id]="'standardDetailsSaveButton'">Save</button>
		<button ejs-button type="button" iconCss="fa fa-close" (click)="returnToList(false)" [attr.data-test-id]="'standardDetailsCancelButton'">Cancel</button>
	</div>
</form>
